var React = require('react');

function IconMenu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.5 0H.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM17.5 6H.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM17.5 12H.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z"}));
}

IconMenu.defaultProps = {"width":"18","height":"16","viewBox":"0 0 18 16"};

module.exports = IconMenu;

IconMenu.default = IconMenu;
